@use 'sass:math';

@import 'core';

@import './ads-loader.animations.scss';

/**
 * @prop --ads-loader-color: Default text color
 */

// Animation
$ads-bounce-duration: 1.6s;
$ads-bounce-range: 0.32s;

// Size
$ads-loader-dot-size-xs: 6px;
$ads-loader-dot-size-sm: 8px;
$ads-loader-dot-size-md: 10px;
$ads-loader-dot-size-lg: 12px;
$ads-loader-dot-size-xl: 14px;

$ads-loader-text-size-xs: 8px;
$ads-loader-text-size-sm: 10px;
$ads-loader-text-size-md: 12px;
$ads-loader-text-size-lg: 14px;
$ads-loader-text-size-xl: 16px;

/**
 * Mixin for size change
 * It would have been simpler to use custom variables but IE 11 does not support it.
 */
@mixin apply-size($dot-size, $font-size) {
  & .dots .dot {
    height: $dot-size;
    width: $dot-size;
  }

  & .text {
    font-size: $font-size;
  }
}

:host {
  display: inline-block;
}

:host([theme='default']) {
  @include ads-vars-component-loader-default;
}

:host([theme='dark']) {
  @include ads-vars-component-loader-dark;
}

.ads-loader {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  & .dots {
    display: flex;
    flex-direction: row;
    justify-content: center;

    & .dot {
      animation: ads-bounce $ads-bounce-duration ease-in-out 0s infinite both;
      background-color: var(--ads-loader-color, $ads-loader-color);
      border: none;
      border-radius: 100%;
      display: block;
      height: $ads-loader-dot-size-md;
      margin: 0 2px;
      width: $ads-loader-dot-size-md;

      &:nth-child(1) {
        animation-delay: -$ads-bounce-range;
      }

      &:nth-child(3) {
        animation-delay: math.div($ads-bounce-range, 2);
      }
    }
  }

  & .text {
    @include ads-paragraph;
    color: var(--ads-loader-color, $ads-loader-color);
    font-size: $ads-loader-text-size-md;
    font-family: var(--ads-font-family);
    margin-top: 2px;
  }

  /**
   * Sizes
   */
  &[data-size='xs'] {
    @include apply-size($ads-loader-dot-size-xs, $ads-loader-text-size-xs);
  }

  &[data-size='sm'] {
    @include apply-size($ads-loader-dot-size-sm, $ads-loader-text-size-sm);
  }

  &[data-size='md'] {
    @include apply-size($ads-loader-dot-size-md, $ads-loader-text-size-md);
  }

  &[data-size='lg'] {
    @include apply-size($ads-loader-dot-size-lg, $ads-loader-text-size-lg);
  }

  &[data-size='xl'] {
    @include apply-size($ads-loader-dot-size-xl, $ads-loader-text-size-xl);
  }
}
